
import { createEntityAdapter, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Location } from "../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall"
import store from "..";


export const sectionDataAdapter = createEntityAdapter({
  selectId: (item: Location) => item.location_id
});


export const activeSectionSlice = createSlice({
  name: "section",
  initialState: sectionDataAdapter.getInitialState({loading: "idle"}),
  reducers: {
    addActiveLocations: (state, {payload}: PayloadAction<Location[]>) => {
      state.loading = "false";
      sectionDataAdapter.addMany(state, payload);
    },
    updateActiveLocation: sectionDataAdapter.updateOne,
    resetActiveLocations: sectionDataAdapter.upsertMany,
    clearActiveLocations: sectionDataAdapter.removeAll,
  }
})

export const {addActiveLocations, resetActiveLocations, clearActiveLocations} = activeSectionSlice.actions;
export const {selectById: selectActiveSectionById, selectAll: selectAllActiveSections} = sectionDataAdapter.getSelectors()